export default {
	title: 'Mes rendez-vous médicaux',
	grossesse: {
		mois0: {
			moisencours: [
				{
					text: 'Ma 1<sup>ère</sup> échographie entre le {dateDebutEchographie} et {dateFinEchographie}.',
					echographie: 1
				},
				{
					text: 'Mon 1<sup>er</sup> examen prénatal chez mon médecin ou ma sage-femme.'
				}
			],
			titreMoisProchain: 'A ne pas manquer le 4<sup>ème</sup> mois',
			moisprochain: [
				{
					text: 'mon 2<sup>ème</sup> examen prénatal.'
				},
				{
					text: 'ma 1<sup>ère</sup> séance de préparation à la naissance et à la parentalité.'
				}
			]
		},
		mois1: {
			moisencours: [
				{
					text: 'Ma 1<sup>ère</sup> échographie entre le {dateDebutEchographie} et {dateFinEchographie}.',
					echographie: 1
				},
				{
					text: 'Mon 1<sup>er</sup> examen prénatal chez mon médecin ou ma sage-femme.'
				}
			],
			titreMoisProchain: 'A ne pas manquer le 4<sup>ème</sup> mois',
			moisprochain: [
				{
					text: 'mon 2<sup>ème</sup> examen prénatal.'
				},
				{
					text: 'ma 1<sup>ère</sup> séance de préparation à la naissance et à la parentalité.'
				}
			]
		},
		mois2: {
			moisencours: [
				{
					text: 'Ma 1<sup>ère</sup> échographie entre le {dateDebutEchographie} et {dateFinEchographie}.',
					echographie: 1
				},
				{
					text: 'Mon 1<sup>er</sup> examen prénatal chez mon médecin ou ma sage-femme.'
				}
			],
			titreMoisProchain: 'A ne pas manquer le 4<sup>ème</sup> mois',
			moisprochain: [
				{
					text: 'Mon 2<sup>ème</sup> examen prénatal.'
				},
				{
					text: 'Mon entretien prénatal précoce'
				}
			]
		},
		mois3: {
			moisencours: [
				{
					text: 'Mon 2<sup>ème</sup> examen prénatal chez mon médecin ou ma sage-femme.'
				},
				{
					text: 'Mon entretien prénatal précoce'
				}
			],
			titreMoisProchain: 'A ne pas manquer le 5<sup>ème</sup> mois',
			moisprochain: [
				{
					text: 'Ma 2<sup>ème</sup> échographie entre le {dateDebutEchographie} et {dateFinEchographie}.',
					echographie: 2
				},
				{
					text: 'Mon 3<sup>ème</sup> examen prénatal.'
				}
			]
		},
		mois4: {
			moisencours: [
				{
					text: 'Ma 2<sup>ème</sup> échographie entre le {dateDebutEchographie} et {dateFinEchographie}.',
					echographie: 2
				},
				{
					text: 'Mon 3<sup>ème</sup> examen prénatal chez mon médecin ou ma sage-femme.'
				}
			],
			titreMoisProchain: 'A ne pas manquer le 6<sup>ème</sup> mois',
			moisprochain: [
				{
					text: 'Mon 4<sup>ème</sup> examen prénatal.'
				}
			]
		},
		mois5: {
			moisencours: [
				{
					text: 'Mon 4<sup>ème</sup> examen prénatal chez mon médecin ou ma sage-femme.'
				}
			],
			titreMoisProchain: 'A ne pas manquer le 7<sup>ème</sup> mois',
			moisprochain: [
				{
					text: 'Mon 5<sup>ème</sup> examen prénatal.'
				},
				{
					text: 'Je planifie mes sept séances de préparation à la naissance et à la parentalité.'
				}
			]
		},
		mois6: {
			moisencours: [
				{
					text: 'Mon 5<sup>ème</sup> examen prénatal chez mon médecin ou ma sage-femme.'
				},
				{
					text: 'Mes séances de préparation à naissance et à la parentalité.'
				}
			],
			titreMoisProchain: 'A ne pas manquer le 8<sup>ème</sup> mois',
			moisprochain: [
				{
					text: 'Ma 3<sup>ème</sup> échographie entre le {dateDebutEchographie} et {dateFinEchographie}.',
					echographie: 3
				},
				{
					text: 'Mon 6<sup>ème</sup> examen prénatal.'
				},
				{
					text: 'Ma consultation avec l\'anesthésiste.'
				}
			]
		},
		mois7: {
			moisencours: [
				{
					text: 'Ma 3<sup>ème</sup> échographie entre le {dateDebutEchographie} et {dateFinEchographie}.',
					echographie: 3
				},
				{
					text: 'Mon 6<sup>ème</sup> examen prénatal chez mon médecin ou ma sage-femme.'
				},
				{
					text: 'Ma consultation avec l\'anesthésiste.'
				},
				{
					text: 'Mes séances de préparation à la naissance et à la parentalité.'
				}
			],
			titreMoisProchain: 'A ne pas manquer le 9<sup>ème</sup> mois',
			moisprochain: [
				{
					text: 'Mon 7<sup>ème</sup> examen prénatal.'
				}
			]
		},
		mois8: {
			moisencours: [
				{
					text: 'Mon 7<sup>ème</sup> examen prénatal chez mon médecin ou ma sage-femme.'
				},
				{
					text: 'Mes dernières séances de préparation à la naissance et à la parentalité.'
				}
			],
			titreMoisProchain: '',
			moisprochain: [
			]
		},
		mois9: {
			moisencours: [
				{
					text: 'Mon 7<sup>ème</sup> examen prénatal chez mon médecin ou ma sage-femme.'
				},
				{
					text: 'Mes dernières séances de préparation à la naissance et à la parentalité.'
				}
			],
			titreMoisProchain: '',
			moisprochain: [
			]
		}
	}
};
